import React from 'react';

import { FormBlock } from '@/app/_components/Form';
import { FormBlockProps } from './types';

import classes from './index.module.scss';

export const FormBlockGraphQL: React.FC<FormBlockProps> = props => {
  const {
    id,
  } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <FormBlock formBlock={props} />
    </div>
  );
};

export default FormBlockGraphQL;
